import { __decorate, __metadata } from 'tslib';
import { Service, WorkbenchSettingsService, ControllerProvider, InjectorService, ServiceCollection, AdapterMatchMiddleware, getCallbackName } from '@tencent/workbench';
import { FormService } from './form-service.js';

/**
 * Workbench Form 扩展，为 Workbench 增加表单配置能力
 *
 * @public
 */
let FormExtension = class FormExtension {
    constructor(settings) {
        this.settings = settings;
        this.version = '1.12.1';
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        ControllerProvider.prototype.formItems = [];
    }
    $onMount() {
        var _a;
        InjectorService.alias('form', FormService);
        const formService = InjectorService.get(FormService);
        InjectorService.get(ServiceCollection).add(formService, {
            itemName: 'formItems',
        });
        formService.setSchema((_a = this.settings.get('form.schema')) !== null && _a !== void 0 ? _a : {});
    }
    initMiddlewares(middlewareService, settings) {
        middlewareService.use(AdapterMatchMiddleware, {
            on: FormService,
            callbackNames: [getCallbackName(settings.get('form'))],
        });
    }
};
FormExtension = __decorate([
    Service(),
    __metadata("design:paramtypes", [WorkbenchSettingsService])
], FormExtension);

export { FormExtension };
//# sourceMappingURL=extension-loader.js.map
